import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.serviceSales.periodTypeOptions);
  const selectedOptions = useSelector((state) => state.serviceSales.selectedFilters.period_type);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOptions}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};

export default PeriodType;
